<template>
  <Transition
    :enter-active-class="$style.from"
    :leave-active-class="$style.from"
    :enter-from-class="$style.to"
    :leave-to-class="$style.to"
    appear
  >
    <slot />
  </Transition>
</template>

<style module>
.from {
  transition: opacity var(--transition-cubic);
}
.to {
  opacity: 0;
}
</style>
